/** Shared formatting helpers for the zoom-call analysis views. */

export const formatLabel = (val: string) =>
  val.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

export const isEmpty = (v: unknown): boolean =>
  v === null ||
  v === undefined ||
  v === "" ||
  (Array.isArray(v) && v.length === 0) ||
  (typeof v === "object" && v !== null && Object.keys(v).length === 0);

/**
 * Technical/metadata keys (identifiers, model names) that must never be shown to the
 * user, wherever they appear in a payload. Applied by every generic key/value renderer.
 */

/**
 * Coerce an untyped payload value to a trimmed string, or null when empty/absent.
 * Guards `.trim()` call sites against numbers (or anything else) arriving in
 * string-shaped slots.
 */
export const asTrimmedString = (v: unknown): string | null => {
  if (v === null || v === undefined) return null;
  const s = String(v).trim();
  return s === "" ? null : s;
};

export const isHiddenTechnicalKey = (key: string): boolean =>
  /^(uid|uuid|id|model)$/i.test(key) || /_(uid|uuid|id)$/i.test(key);
